// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"ae4032e0","410":"0dda79d8","983":"6a7b3b4f"}[chunkId] + ".chunk.css";
};